// test1902
(1902 && 0);
